const menu = '[data-test="tenant-feature-settings"]'
const later = { unless: menu }
const settings = [
  { key: 'users', selector: '[data-test="tenant-menu.access"]', menu: true, article: true },
  { key: 'documents', selector: '[data-test="tenant-menu.documents"]', menu: true },
  { key: 'fields', selector: '[data-test="tenant-menu.fields"]', menu: true },
  { key: 'finish', selector: '[data-test="help-trigger"]', required: true }
]

export const managementOrientationStages = {
  overview: [
    { key: 'home', selector: '[data-test="start-navigation"]', required: true },
    { key: 'search', selector: '[data-test="global-search-trigger"]', fallback: '[data-test="global-search-mobile"]', required: true },
    { key: 'sidebar', selector: '[data-test="side-menu.icons"]', fallback: '[data-test="management-menu-trigger"]', fallbackKey: 'sidebar_mobile', required: true },
    { key: 'tenant', selector: '[data-test-name="tenant-menu-trigger"]', requiresAny: '[data-test="tenant-menu.switch"], [data-test="tenant-menu.club"], [data-test="tenant-menu.settings"]' },
    { key: 'switch', selector: '[data-test="tenant-menu.switch"]', menu: true },
    { key: 'club', selector: '[data-test="tenant-menu.club"]', menu: true },
    { key: 'features', selector: menu, menu: true, navigate: 'features' },
    ...settings.map(step => ({ ...step, ...later }))
  ],
  features: [
    { key: 'feature_panel', selector: '[data-panel="feature_settings"]', required: true },
    { key: 'smtp', selector: '[data-test="tenant-menu.smtp"]', menu: true },
    { key: 'person_settings', selector: '[data-test="tenant-menu.person-settings"]', menu: true, navigate: 'person-settings' }
  ],
  'person-settings': [
    { key: 'person_panel', selector: '[data-panel="person_settings"]', required: true },
    ...settings
  ]
}
